import React from 'react';

import clsx from 'clsx';

import css from './index.module.css';

export type ButtonTheme =
  | 'primary'
  | 'outline'
  | 'secondary'
  | 'none'
  | 'danger-outline'
  | 'danger'
  | 'gray'
  | 'bg-white-outline';

export type ButtonColor = 'black' | 'white';

export type ButtonWrapperProps = {
  dataTestId?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  onMouseLeave?: () => void;
  disabled?: boolean;
  label?: string;
  theme?: ButtonTheme;
  color?: ButtonColor;
  type?: 'submit' | 'button' | 'reset';
  id?: string;
};

const ButtonWrapper = ({
  children,
  onClick,
  onMouseLeave,
  disabled,
  label,
  dataTestId,
  color,
  theme = 'primary',
  type = 'button',
  id = 'id',
}: ButtonWrapperProps) => {
  const classStack = clsx(
    css[theme],
    css[color || ''],
    disabled ? 'cursor-not-allowed opacity-70' : '',
  );

  return (
    <button
      id={id}
      data-testid={dataTestId}
      className={classStack}
      disabled={disabled}
      aria-busy={disabled}
      aria-disabled={disabled}
      type={type}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
    >
      {children || label}
    </button>
  );
};

export default ButtonWrapper;
